import React, { useEffect, useState ,useContext} from "react";
import { useTranslation } from "next-i18next";
import style from "../../../styles/mystyle.module.css";
import config from "../../../next.config";
import { useRouter } from "next/router";
import SeeMore from "../SeeMore";
import axios from "axios";
import {getTermsByVocabCodes} from "../../helpers/global/term/term";
import getIncludeStatusIds from "../../helpers/global/getIncludeStatusIds";
import Link from "next/link";
import { constants } from "../../../constants";
// import TermsContext from "../../../context/Trems"
import Loading from "../../../components/components/Loaders/Loading";
import {getImage} from '../../helpers/images'
import {getCookieValue} from '../../helpers/helpers'
function Dietoffers() {
  const [LoadMore, setLoadMore] = useState(false);
  const [loading, setloading] = useState(true);
  const [pageId, setpageId] = useState(0);
  const [SponsorsData, setSponsorsData] = useState([]);
  const [SponsorsImage, setSponsorsImage] = useState([]);
  const [NotFound, setNotFound] = useState(false);

  let typeCodeLst = ["productUnitPrice", "product"]

  const getData = epageId => {
    setpageId(epageId);
    getTermsByVocabCodes(["sponsor-entity-types"]).then(termRes=>{
           let sponsorEntityTypeId =JSON.parse(termRes).filter(item => typeCodeLst.includes(item.code)).map(item => item.id)
          
     
            // let DisplaylocationId = JSON.parse(res).filter(i => i.code == "main")[0].id;
            getIncludeStatusIds()
              .then(res => {
                let StatusIds = res;
                let SearchData = {
                  
                  statusId: JSON.stringify(StatusIds),
                  // mainScreen: true,
                  currentDate: new Date().valueOf(),
                  // displayLocationId : DisplaylocationId,
                  sponsorEntityTypeId: JSON.stringify(sponsorEntityTypeId),
                  // paid:1,
                  limit: 10,
                  pageId: epageId
                };
                if (getCookieValue("userCountry")) {
                  SearchData.userCountryCode = getCookieValue("userCountry")
                }
                axios
                  .get(`${config["basePath"]}/api/sponsors/get`, {
                    params: SearchData
                  })
                  .then(res => {  
                
                        
                    setloading(false);
                    if (res.data.data.length > 0) {

                      res.data.data.map(async i => {
                        if (i.files && i.files.length > 0 && i.files[0].filePath) {
                         
                            let img=await getImage(i.files[0].fileId,i.files[0].filePath)
                              let resImage = [{ image: img, id: i.id }];
    
                              setSponsorsImage(prev => [...prev, ...resImage]);
                            
                        }
                      });

                      if (epageId > 1) {
                        setSponsorsData(prevState => [...prevState, ...res.data.data]);
                      } else {
                        setSponsorsData([...res.data.data]);
                      }
                  


              
                    } else {
                      setLoadMore(false);
                          setNotFound(true)
                    }

              
                    if(SearchData.limit== res.data.numberOfElements){
                      if(SearchData.limit*SearchData.pageId< res.data.totalElements){
                        setLoadMore(true);
                       }  else{
                            setLoadMore(false);
                            setNotFound(true)
                        }}
                  })
                  .catch(err => (err));
              })
              .catch(err => (err));
            })
  
  };

  useEffect(() => {
    getData(1);
    setSponsorsData([]);
  }, []);

  //   const loadMoreData = useCallback(() => {
  //   let tempPageId= pageId + 1;

  //   getData(tempPageId);

  //   }, [SponsorsData]);
  const router = useRouter();
  const { t } = useTranslation("common");
  return (
    <div className={style.SectionContainer}>
      <div className={style.allcard}>
        <div className={style.Offer}>
            {/* {console.log("sponsorData===========>", SponsorsData.filter(
                (i, x) =>
                  x ==
                  SponsorsData.findIndex(
                    w => w.id == i.id
                  )
              ))} */}
       {/* {console.log("SponsorsData==========>", SponsorsData.filter(
                (i, x) =>
                  x ==
                  SponsorsData.findIndex(
                    w => w.id == i.id
                  )
              ))} */}
          {SponsorsData && SponsorsData.length > 0
            ? SponsorsData.filter(
                (i, x) =>
                  x ==
                  SponsorsData.findIndex(
                    w => w.id == i.id
                  )
              ).length>0 &&
              SponsorsData.filter(
                (i, x) =>
                  x ==
                  SponsorsData.findIndex(
                    w => w.id == i.id
                  )
              ).map(item => {
                
                if (item.url) {
                  return (
                    <Link href={item.url}>
            
                        <div className={style.fullwidth}>
                          <img
                            className={style.imgoffer}
                            key={item.id}
                            src={
                               SponsorsImage &&
                              SponsorsImage.length > 0 &&
                              SponsorsImage.filter(i => i.id == item.id).length >
                                0 &&
                              SponsorsImage.filter(i => i.id == item.id)[0].image !=
                                ""
                                ? SponsorsImage &&
                                  SponsorsImage.filter(i => i.id == item.id)[0]
                                    .image
                                : `${config.basePath}/assets/images/defaultSponsorImage.jpg`
                            }
                            alt={item.alt}
                          />
                        </div>
                
                    </Link>
                  );
                }
                else{
                 
                  if (
                    item.sponsorEntityType.length > 0 &&
                    item.sponsorEntityType[0].code == "product"
                  ) {
                    
                if (item.entityId&&item.identifierId) {
                    return (
                      <Link
                      href={`/${constants.productUrl}/${
                        item.slug.length > 0 &&
                        item.slug.filter(i => i.active == true).length > 0
                          ? item.slug.filter(i => i.active == true)[0].url+"/"+item.identifierId
                          : item.entityId+"/"+item.identifierId
                      } `.replace("/[^a-zA-Z0-9-_]/g", "")}
                      as={`/${constants.productUrl}/${
                        item.slug.length > 0 &&
                        item.slug.filter(i => i.active == true).length > 0
                          ? item.slug.filter(i => i.active == true)[0].url+"/"+item.identifierId
                          : item.entityId+"/"+item.identifierId
                      } `.replace("/[^a-zA-Z0-9-_]/g", "")}
                  
                      >
              
                      <div className={style.fullwidth}>
                      <img
                      className={style.imgoffer}
                        key={item.id}
                        src={
                          SponsorsImage &&
                                SponsorsImage.length > 0 &&
                                SponsorsImage.filter(i => i.id == item.id).length >
                                  0 &&
                                SponsorsImage.filter(i => i.id == item.id)[0].image !=
                                  ""
                                  ? SponsorsImage &&
                                    SponsorsImage.filter(i => i.id == item.id)[0]
                                      .image
                                  : `${config.basePath}/assets/images/defaultSponsorImage.jpg`
                        }
                        alt={item.alt}
                   
                      />
                          </div>
                   
                   
                    </Link>
                    );   
                 } 
                 else if (item.entityId&&!item.identifierId) {
                  return (
                    <Link
                    href={`/${constants.productUrl}/${
                      item.slug.length > 0 &&
                      item.slug.filter(i => i.active == true).length > 0
                        ? item.slug.filter(i => i.active == true)[0].url
                        : item.entityId
                    } `.replace("/[^a-zA-Z0-9-_]/g", "")}
                    as={`/${constants.productUrl}/${
                      item.slug.length > 0 &&
                      item.slug.filter(i => i.active == true).length > 0
                        ? item.slug.filter(i => i.active == true)[0].url
                        : item.entityId
                    } `.replace("/[^a-zA-Z0-9-_]/g", "")}
                
                    >
            
                    <div className={style.fullwidth}>
                    <img
                    className={style.imgoffer}
                      key={item.id}
                      src={
                        SponsorsImage &&
                              SponsorsImage.length > 0 &&
                              SponsorsImage.filter(i => i.id == item.id).length >
                                0 &&
                              SponsorsImage.filter(i => i.id == item.id)[0].image !=
                                ""
                                ? SponsorsImage &&
                                  SponsorsImage.filter(i => i.id == item.id)[0]
                                    .image
                                : `${config.basePath}/assets/images/defaultSponsorImage.jpg`
                      }
                      alt={item.alt}
                 
                    />
                        </div>
                 
                 
                  </Link>
                  );   
               } 
                   else {
                    return (
                      <div className={style.fullwidth}>
                        <img
                          className={style.imgoffer}
                          key={item.id}
                          src={
                            SponsorsImage &&
                            SponsorsImage.length > 0 &&
                            SponsorsImage.filter(i => i.id == item.id).length >
                              0 &&
                            SponsorsImage.filter(i => i.id == item.id)[0].image !=
                              ""
                              ? SponsorsImage &&
                                SponsorsImage.filter(i => i.id == item.id)[0]
                                  .image
                              : `${config.basePath}/assets/images/defaultSponsorImage.jpg`
                          }
                          alt={item.alt}
                        />
                      </div>
                    );
                  }
                }

                if (
                  item.sponsorEntityType.length > 0 &&
                  item.sponsorEntityType[0].code == "productUnitPrice"
                ) {
                  if (item.entityId) {
                      return (
                        <Link
                        href={item.product.length>0?    item.product[0].slug.length>0? ("/products"+item.product[0].slug[0].url+"/"+item.entityId):("/products/"+item.product[0].id+"/"+item.entityId):"/" }
                        as={item.product.length>0?    item.product[0].slug.length>0? ("/products"+item.product[0].slug[0].url+"/"+item.entityId):("/products/"+item.product[0].id+"/"+item.entityId):"/" }

                        >
                
                        <div className={style.fullwidth}>
                        <img
                        className={style.imgoffer}
                          key={item.id}
                          src={
                            SponsorsImage &&
                                  SponsorsImage.length > 0 &&
                                  SponsorsImage.filter(i => i.id == item.id).length >
                                    0 &&
                                  SponsorsImage.filter(i => i.id == item.id)[0].image !=
                                    ""
                                    ? SponsorsImage &&
                                      SponsorsImage.filter(i => i.id == item.id)[0]
                                        .image
                                    : `${config.basePath}/assets/images/defaultSponsorImage.jpg`
                          }
                          alt={item.alt}
                     
                        />
                            </div>
                     
                     
                      </Link>
                      );   
                   } 
                   
                     else {
                      return (
                        <div className={style.fullwidth}>
                          <img
                            className={style.imgoffer}
                            key={item.id}
                            src={
                              SponsorsImage &&
                              SponsorsImage.length > 0 &&
                              SponsorsImage.filter(i => i.id == item.id).length >
                                0 &&
                              SponsorsImage.filter(i => i.id == item.id)[0].image !=
                                ""
                                ? SponsorsImage &&
                                  SponsorsImage.filter(i => i.id == item.id)[0]
                                    .image
                                : `${config.basePath}/assets/images/defaultSponsorImage.jpg`
                            }
                            alt={item.alt}
                          />
                        </div>
                      );
                    }
                  }
              }
              })
            : ""}
       

          {LoadMore == true ? (
            <div>
              {" "}
              <SeeMore
                getMore={event => {
                  setloading(true);
                  let tempPageId = pageId + 1;
                  getData(tempPageId);
                }}
                loading={loading}
                text={t("SeeMore")}
              />
            </div>
          ) : ""}
               {   NotFound == true ?
           <div className={style.fullwidth}>
           <img
           className={style.imgoffer}
           
             src={
           `${config.basePath}/assets/images/defaultSponsorImage.jpg`
             }
             alt={"defaultSponsorImage"}
           
           />
               </div>
            :""}
        </div>
        <div style={{ textAlign: "center",display:"flex",justifyContent:"center"  }}>
          {" "}
          {loading ? <Loading /> : ""}
        </div>
      </div>
    </div>
  );
}

export default Dietoffers;
